<template>
    <div class="slide-app">
        <div v-if="presentation !== undefined">
            <visualpanel v-on:newCurrentSlide="getCurrentSlide($event)" :progressiveReveal="progressiveReveal" :user="user" :service="service" :slideList="slideList" :presentation="presentation" :syncSlideNum="syncSlideNum"></visualpanel>
            <div class="slide-title-bar">
                <div class="presenter-icon">
                    <img class="presenter-portrait" v-on:click="togglePresenterCard()" :src="pictureUrl" onerror='this.onerror = "null"; this.src = "/static/img/anonymous.svg"'> 
                    <span v-if="presentation.props.PresenterProfiles && presentation.props.PresenterProfiles.profiles.length > 1" class="presenter-count">{{presentation.props.PresenterProfiles.profiles.length}}</span>                            
                </div>
                <div class="session-title">{{presentation.title}}</div>
                <div class="resources-tab">
                    <img v-if="isResourceAvailable" class="arrow" src="../assets/icons/arrow.svg" :class="isResourceOpen ? 'rotate' : ''" v-on:click="toggleTray()">
                    <resourcestray v-if="isResourceAvailable && isResourceOpen" v-on:closeResources="toggleTray" :surveys="surveys" :currentSlide="currentSlide" :slideList="slideList" :presentation="presentation" :user="user"></resourcestray>
                </div>
            </div>
            <presentercard v-if="cardOpen" :profileIndex="profileIndex" :presentation="presentation" v-on:scrollProfile="scrollProfile($event)" v-on:closeCard="closePresenterCard($event)"></presentercard>
        </div>
        <div class='survey-container' v-if='isSurveyVisible'>
            <div class="overlay" v-on:click='dismissSurvey'></div>
            <survey :survey="jsonSurvey" css-path='survey-1.2.0.css' localization-path='survey/localization' :user='user' :onSubmit='onSubmitSurvey' :onFail='onFailSurvey'></survey>
        </div>
    </div>   
</template>

<script>

import PresenterCard from '@/components/PresenterCard';
import VisualPanel from '@/components/VisualPanel';
import ResourcesTray from '@/components/ResourcesTray';
import Survey from '@/../submodules/survey-web/dist/1.2.0/survey/templates/survey-1.2.0.vue';
import {EventBus} from '../router/index';

export default {
    components: {
        visualpanel: VisualPanel,
        presentercard: PresenterCard,
        resourcestray: ResourcesTray,
        survey: Survey
    },

    props: {
        presentation: {},
        user: {},
        slideList: {},
        syncSlideNum: {},
        currentSlide: '',
        progressiveReveal: {},
        surveys: {},
        service: {}
    },

    data () {
        return {
            cardOpen: false,
            isResourceOpen: false,
            profileIndex: 0,
            notesOpen: false,
            initialOpen: false,
            isSurveyVisible: false,
            jsonSurvey: undefined,
            onSubmitSurvey: undefined,
            onFailSurvey: undefined,
            onCancelSurvey: undefined,
            lastPresentationId: undefined
        };
    },

    computed: {
        isResourceAvailable() {
            if (!this.slideList || !this.slideList[this.currentSlide] || !this.presentation || !this.presentation.props) {
                return false;
            }

            if (this.presentation.props.SurveyInstances && this.presentation.props.SurveyInstances.length > 0) {
                return true;
            }

            if (!this.presentation.props.Resources) {
                return false;
            }

            let slideNum = this.slideList[this.currentSlide].slideId;
            let resources = this.presentation.props.Resources[slideNum];
            let surveyExists = this.surveys ? !!this.surveys.length : false;

            return !this.notesOpen && (surveyExists || (resources && ((resources.Files && resources.Files.length > 0) || (resources.Links && resources.Links.length > 0) || (resources.Notes && resources.Notes.length > 0))));
        },

        pictureUrl() {
            if (!this.presentation || !this.presentation.props) {
                return "../assets/icons/anonymous.svg";
            }

            if (this.presentation.props.PresenterInfo) {
                return this.presentation.props.PresenterInfo.pictureURL;
            }

            if (this.presentation.props.PresenterProfiles && this.presentation.props.PresenterProfiles.profiles && this.presentation.props.PresenterProfiles.profiles[this.profileIndex]) {
                return this.presentation.props.PresenterProfiles.profiles[this.profileIndex].pictureURL;
            }

            return "../assets/icons/anonymous.svg";
        }
    },

    mounted() {
        EventBus.$on('disableResourcePane', () => {
            this.notesOpen = true;
        });

        EventBus.$on('enableResourcePane', () => {
            this.notesOpen = false;
        });
        
        EventBus.$on('startSurvey', (json, onSubmit, onFail, onCancel) => {
            if (json && json !== '') {
                this.isSurveyVisible = true;
            }

            this.jsonSurvey = json;

            this.onSubmitSurvey = (json) => {
                this.isSurveyVisible = false;

                if (onSubmit) {
                    onSubmit(json);
                }
            };

            this.onFailSurvey = (err) => {
                this.isSurveyVisible = false;

                if (onFail) {
                    onFail(err);
                }
            };

            this.onCancelSurvey = onCancel;
        });

        EventBus.$on('closeModals', () =>{
            this.closePresenterCard();
        });
    },

    methods: {
        togglePresenterCard() {
            this.cardOpen = !this.cardOpen;
        },

        getCurrentSlide(newSlide) {
            this.$emit('currentSlide', newSlide);
        },

        toggleTray () {
            this.isResourceOpen = !this.isResourceOpen;
        },

        scrollProfile(direction) {
            var numProfiles = this.presentation.props.PresenterProfiles.profiles.length;

            if (direction === 'left') {
                this.profileIndex -= 1;

                if (this.profileIndex < 0) {
                    this.profileIndex = numProfiles - 1;
                }
            } else if (direction === 'right') {
                this.profileIndex += 1;

                if (this.profileIndex >= numProfiles) {
                    this.profileIndex = 0;
                }
            }
        },

        closePresenterCard () {
            this.cardOpen = false;
        },

        dismissSurvey() {
            this.isSurveyVisible = false;

            if (this.onCancelSurvey) {
                this.onCancelSurvey();
            }
        }
    },

    watch: {
        slideList() {
            if (!this.slideList || !this.slideList[this.currentSlide]) {
                this.isResourceOpen = false;
                this.initialOpen = false;
                return;
            }

            var slideId = this.slideList[this.currentSlide].slideId;
            var surveyExists = this.presentation.props.Surveys || this.presentation.props.SurveyInstances ? true : undefined;
            var resourcesExist = this.presentation.props.Resources && this.presentation.props.Resources[slideId] ? true : undefined;
            var openPane = surveyExists || resourcesExist ? true : undefined;

            if (this.slideList && !this.initialOpen && openPane) {
                this.isResourceOpen = true;
                this.initialOpen = true;
            }
        },

        presentation() {
            if (this.presentation.id !== this.lastPresentationId) {
                this.cardOpen = true;
                this.lastPresentationId = this.presentation.id;
            }
        }
    }
};

</script>

<style lang="scss">

.slide-app {
    height: calc(100vh - 121px);
    position: relative;

    .slide-title-bar {
        position: fixed;
        bottom: 60px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid #d4451d;

        .presenter-icon {
            cursor: pointer;

            .presenter-portrait {
                width: 40px;
                height: 40px;
            }

            img {
                max-height: 40px;
                margin-left: 12px;
                margin-bottom: 10px;
                border-radius: 50%;
                border-style: none;
            }
        }

        .presenter-count {
            border-radius: 50%;
            background-color: #666;
            color: #fff;
            font-size: 13px;
            font-family: 'Poppins', sans-serif;
            text-align: center;
            position: absolute;
            left: 40px;
            top: 23px;
            width: 20px;
            z-index: 10;
        }

        .session-title {
            color: #fff;
            font-family: 'Poppins', sans-serif;
            font-size: 0.8em;
            margin-top: 10px;
            text-align: center;
        }

        .resources-tab {
            margin: 8px 12px 8px 0;

            .arrow {
                width: 30px;
                vertical-align: middle;
            }
        }
    }

    .survey-container {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        .overlay {
            position: fixed;
            z-index: 5001;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.4);
        }

        & > div:last-child {
            position: absolute;
            background-color: white;
            z-index: 5002;

            @media screen and (max-width: 650px) {
                left: 20px;
                right: 20px;
            }

            @media screen and (min-width: 650px) {
                left: 100px;
                right: 100px;
            }

            @media screen and (max-height: 500px) {
                top: 20px;
                bottom: 20px;
            }

            @media screen and (min-height: 500px) {
                top: 40px;
                bottom: 40px;
            }
        }
    }
}

.rotate {
    transform: rotate(180deg);
}

</style>



// WEBPACK FOOTER //
// SessionApp.vue?1e48c9be